











import { Component, Prop, Vue } from 'vue-property-decorator';

import InputComponent from '@/components/FormElements/InputComponent.vue';
import LabelComponent from '@/components/FormElements/LabelComponent.vue';
import SelectComponent from '@/components/FormElements/SelectComponent.vue';

@Component({
  components: {
    SelectComponent,
    InputComponent,
    LabelComponent,
  },
})
export default class MultipleChoiceDropdownResponse extends Vue {
  @Prop() public readonly value!: string | string[];
  @Prop(Array) public readonly choices!: string[];

  get choicesAsOptions() {
    return this.choices.map((choice) => {
      return { value: choice, text: choice };
    });
  }

  get selectedChoice() {
    return this.value;
  }

  set selectedChoice(newValue) {
    this.$emit('input', newValue);
  }
}
